export default "__VITE_ASSET__t6dK2im5__"